import { useEffect } from "react";
import fetch from "../auth/FetchInterceptor";
import { PLAN_TYPE } from "./OrderService";

// export interface qrCodeDataInterface {
//   orderId: string;
//   qrType: string;
//   qrId: string;
//   warehouse: string;
// }

export interface calculatorInterface {
  weight: number;
  length: number;
  height: number;
  width: number;
  title: string;
  plan: PLAN_TYPE;
  cargo_type: CargoType;
}

export enum CargoType {
  CLOTH = "CLOTH",
  TOY = "TOY",
  BIG_CARGO = "BIG_CARGO",
  SMALL_CARGO = "SMALL_CARGO",
}
export enum CargoTypeColor {
  CLOTH = "magenta",
  TOY = "orange",
  BIG_CARGO = "green",
  SMALL_CARGO = "geekblue",
}

export const CargoTypeTextData = [
  {
    key: CargoType.TOY,
    text_cn: "玩具",
    text_ru: "Игрушки",
  },
  {
    key: CargoType.CLOTH,
    text_cn: "衣服",
    text_ru: "Одежда",
  },
  {
    key: CargoType.BIG_CARGO,
    text_cn: "大百货",
    text_ru: "Смешка",
  },
  {
    key: CargoType.SMALL_CARGO,
    text_cn: "小百货",
    text_ru: "Хоска",
  },
];

const PricelistService = {
  fetchFilter: function (page: number, cargo_type: string, limit = 22) {
    return fetch({
      url: `/priceLists-filter?page=${page}&cargo_type=${cargo_type}&limit=${limit}`,
      method: "get",
      headers: {
        "public-request": "true",
      },
    });
  },
  update: function (data: any, id: string) {
    return fetch({
      url: `/priceLists/${id}`,
      method: "put",
      data: data,
      headers: {
        "public-request": "true",
      },
    });
  },
  getOne: function (data: string) {
    return fetch({
      url: `/priceLists/${data}`,
      method: "get",
      headers: {
        "public-request": "true",
      },
    });
  },

  add: function (data: any) {
    return fetch({
      url: `/priceLists`,
      method: "post",
      data: data,
      headers: {
        "public-request": "true",
      },
    });
  },

  delete: function (data: string) {
    return fetch({
      url: `/priceLists/${data}`,
      method: "delelte",
      headers: {
        "public-request": "true",
      },
    });
  },
  calculator: function (data: calculatorInterface) {
    return fetch({
      url: `/calculator`,
      method: "post",
      data: data,
      headers: {
        "public-request": "true",
      },
    });
  },
};

export default PricelistService;
